import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT } from 'listing-details/constants';
import { SavedListingSection } from 'listing-details/types';

type SectionNameMap = {
    [K in SavedListingSection]: string;
};

export const trackSectionChange = (section: SavedListingSection) => {
    const sectionNameMap: SectionNameMap = {
        'for-sale': 'for sale',
        'to-rent': 'to rent',
        overseas: 'overseas',
        commercial: 'commercial'
    };

    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: `favourite properties>${sectionNameMap[section]}`
    });
};

export const trackNewSearch = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'homepage',
        eventAction: 'clickthrough',
        eventLabel: 'saved properties start search'
    });
};

export const trackDeleteSavedListing = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: 'delete saved property'
    });
};

export const trackPropertyNotesLink = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: 'favourite properties>property notes'
    });
};

export const trackShowExpired = (enabled: boolean) => {
    const label = `${enabled ? 'include' : 'exclude'} expired properties`;

    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'User Account',
        eventAction: 'click',
        eventLabel: label
    });
};
